import { jsx as t } from "react/jsx-runtime";
import { useChatbotContext as i } from "../../hooks/useChatbotContext.js";
function o() {
  const { cn: e, isEditing: n } = i();
  return /* @__PURE__ */ t("div", { className: "flex aspect-square w-5 items-center self-start text-red-600", children: /* @__PURE__ */ t("div", { className: "flex h-6 items-center pl-2", children: /* @__PURE__ */ t(
    "div",
    {
      "data-testid": "chatbot-thinking",
      className: e("dot-falling--v2", {
        "!animate-none before:!animate-none after:!animate-none": n
      })
    }
  ) }) });
}
export {
  o as BotThinkingDots
};
